export const TABS = {
  procedure: "procedure",
  customer: "customer",
};
